module.exports = __webpack_public_path__ + "img/expand_more-black-24dp.2cb922dd.svg";